import Header from '@/components/Layout/Header';
import MenuLayout from '@/components/Layout/MenuLayout.tsx';
import React from 'react';
import { useUserStore } from '@/stores/user.ts';
import { Navigate } from 'react-router-dom';
import { usePermissionsManager } from '@/hooks/usePermissionsManager';

type ProtectedRouteProps = {
  children: React.ReactNode;
}
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {

  const [drawerWidth, setDrawerWidth] = React.useState(window.innerWidth < 1500 ? '220px' : '252px');

  React.useEffect(() => {
    const handleResize = () => {
      setDrawerWidth(window.innerWidth < 1500 ? '220px' : '252px');
    };
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div>
      <Header />
      <MenuLayout />
      <div
        style={{
          marginTop: '65px',
          width: `calc(100% - ${drawerWidth})`,
          marginLeft: drawerWidth,
          padding: '0 15px 15px 15px',
          marginBottom: '-73px',
          background: '#f3f3f3',
          height: '100%',
          minHeight: '100vh',
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default ProtectedRoute;
